import React, { useEffect, useState, useRef } from 'react'
import styles from "./Myproject.module.css"
import Modal from './Modal';
import { current_user_Api, create_environment_Api, create_environment_file_Api, create_project_Api, delete_project_Api, get_all_environment_Api, get_all_project_Api, getLatestProjectPdf, getLatestProjectXML, update_project_Api } from '../../dashboardapi';
import { Navigate, useParams } from 'react-router-dom';
import data from "../../json/Config.json"
import { Link, useNavigate } from 'react-router-dom';
import { Spinner, useToast } from '@chakra-ui/react';
import { downloadFile, downloadURI } from '../../Utils/utils';
import { set, wrap } from 'lodash';
import dashboardmodal from "./ProjectModal.module.css"
import { useOutletContext } from 'react-router-dom';
import templatestyle from "./TemplateModal.module.css"
import ManageStyles from './ManageStyles';
import ManageProjectStyle from './ManageProjectStyle';
import manageStyle from "./Managestyles.module.css"
import { connect } from 'react-redux';
import NewModal from './NewModal';
import epl from "../../clientstyles/eplstyles"
import { InfoOutlineIcon } from "@chakra-ui/icons";
import { eplStyles } from '../../components/AllStyles';
const Myproject = (props) => {
    // const [projectlen, setProjectLen] = useState(0);
    const [showmodal, setShowModal] = useState(false);
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [showAddTemplate, setShowAddTemplate] = useState(false);
    const [projectTitle, setProjectTitle] = useState({ name: "", env: "", date: "" });
    const [projects, setProjects] = useState([]);
    const [search, setSearch] = useState("");
    const [updatedata, setUpdatedata] = useState("");
    const [environment, setEnvironments] = useState([]);
    const [currentProject, setCurrentProject] = useState();
    const [toogle, setToogle] = useState(false);
    const [activeToggleUuid, setActiveToggleUuid] = useState(null);
    const [activeTemplate, setActiveTemplate] = useState("create");
    const [SettingsModal, setSettingsModal] = useState(false);
    const [TemplateactiveTab, TemplateSetActiveTab] = useState("create")
    const [showtemplatemodal, setshowtemplatemodal] = useState(false);
    const [TemplateenvironmentTitle, TemplatesetEnvironmentTitle] = useState("")
    const TemplatefileInputRef = useRef(null);
    const [Templatedragging, TemplatesetDragging] = useState(false);
    const [Templateshow, TemplatesetShow] = useState(false);
    const [TemplateinputFiles, TemplatesetInputFiles] = useState([]);
    const [Templateenvironments, TemplatesetEnvironments] = useState();
    const [TemplateshowDetails, TemplatesetShowDetails] = useState({ show: false, env: "", id: "" })
    const [Templateuserdetail, TemplatesetUserDetail] = useState("")
    const [loading, setLoading] = useState(false);


    const Templateref = useRef();
    const optionref = useRef();
    const indivProjectListRef = useRef(null);
    const optionbuttonref = useRef();
    const newprojectRef = useRef();
    const addatemplateRef = useRef();
    const updateProjectRef = useRef();
    const { ToogleSidebars } = useOutletContext();
    const [dropdownPosition, setDropdownPosition] = useState("bottom");
    const styleRef = useRef();
    // states and code for new applying styles 
    const storeCurrentProject = (items) => {
        console.log("the current items project is :", items)
        setCurrentProject(items);
        setSettingsModal(true);

        try {
            const stored = localStorage.getItem("client");
            if (stored) {
                const clientArray = JSON.parse(stored);
                const entry = clientArray.find(
                    item => item.id === items?.uuid
                );
                if (entry?.styles) setSelectedClientStyles(entry.styles);
            }
        } catch {
            setSelectedClientStyles([]);
        }
    }

    const [selectedClientStyles, setSelectedClientStyles] = useState([]);
    const [selecteddescription, setSelectedDescription] = useState({ name: epl[0]?.name });
    const [showDescription, setShowDescription] = useState(false);
    const [searchStyles, setSearchStyles] = useState("")

    const selectedClient = epl;
    const selectedClientKey = "EPL";

    useEffect(() => {
        if (SettingsModal && epl && Object.keys(epl).length > 0) {
            const firstKey = Object.keys(epl)[0];

            setSelectedDescription({
                name: firstKey,
                value: epl[firstKey],
            });

            setShowDescription(true);
        }
    }, [SettingsModal]);

    const searchingStyles = (e) => {
        setSearchStyles(e.target.value)
    }
    // const filteredStyles = selectedClient
    //     ? Object.entries(selectedClient).filter(([keyName, value]) =>
    //         keyName.toLowerCase().startsWith(searchStyles.toLowerCase())
    //     )
    //     : [];

    const filteredStyles = eplStyles
        ? Object.entries(eplStyles).filter(([keyName, value]) =>
            keyName.toLowerCase().startsWith(searchStyles.toLowerCase())
        )
        : [];




    // useEffect(() => {
    //     try {
    //         const stored = localStorage.getItem("client");
    //         if (stored) {
    //             const clientArray = JSON.parse(stored);
    //             const entry = clientArray.find(
    //                 item => item.id === currentProject?.uuid && item.clients === selectedClientKey.toLowerCase()
    //             );
    //             if (entry?.styles) setSelectedClientStyles(entry.styles);
    //         }
    //     } catch {
    //         setSelectedClientStyles([]);
    //     }
    // }, [currentProject]);

    const handleCheckChange = (key) => {
        setSelectedClientStyles(prev =>
            prev.includes(key)
                ? prev.filter(k => k !== key)
                : [...prev, key]
        );
    };

    const handleStore = (item) => {
        console.log("the current project is :", currentProject);
        if (!selectedClientStyles) return;

        const newEntry = {
            id: currentProject?.uuid,
            clients: selectedClientKey.toLowerCase(),
            styles: selectedClientStyles,
        };

        let clientArray = [];
        try {
            const stored = localStorage.getItem("client");
            const parsed = stored ? JSON.parse(stored) : [];
            clientArray = Array.isArray(parsed) ? parsed : [];
        } catch {
            clientArray = [];
        }

        const existingIndex = clientArray.findIndex(items => items?.id === currentProject?.uuid);
        if (existingIndex !== -1) {
            clientArray[existingIndex] = newEntry;
        } else {
            clientArray.push(newEntry);
        }

        localStorage.setItem("client", JSON.stringify(clientArray));

        toast({
            title: "Stored successfully",
            description: "Stored Successfully",
            status: "success",
            duration: 2000,
            isClosable: true
        });

        setSettingsModal(false);
        setSelectedClientStyles([])
    };

    // useEffect(() => {
    //     function closestylesmodal(e) {
    //         if (styleRef.current && !styleRef.current.contains(e.target)) {
    //             setSettingsModal(false)
    //         }
    //     }
    //     document.addEventListener("click", closestylesmodal);
    //     return () => {
    //         document.removeEventListener("click", closestylesmodal)
    //     }
    // }, [SettingsModal])


    //  new styles  completing here 





    useEffect(() => {
        if (activeToggleUuid && indivProjectListRef.current) {
            if (indivProjectListRef.current.offsetHeight < 200) {
                indivProjectListRef.current.style.paddingBottom = '160px';
                setDropdownPosition("bottom")
            }
        } else if (indivProjectListRef.current) {
            // When no menu is active, remove padding
            indivProjectListRef.current.style.paddingBottom = '0px';
        }
    }, [activeToggleUuid]);

    useEffect(() => {
        function closeCreateProject(e) {
            if (showmodal && newprojectRef.current && !newprojectRef.current.contains(e.target)) {

                setShowModal(false);
            }
        }
        document.addEventListener("mousedown", closeCreateProject);
        return () => document.removeEventListener("mousedown", closeCreateProject);
    }, [showmodal]);

    useEffect(() => {
        function closeaddatemplate(e) {
            if (showtemplatemodal && addatemplateRef.current && !addatemplateRef.current.contains(e.target)) {
                setshowtemplatemodal(false);
            }
        }
        document.addEventListener("mousedown", closeaddatemplate);
        return () => document.removeEventListener("mousedown", closeaddatemplate);
    }, [showtemplatemodal]);

    useEffect(() => {
        function closeUpdateProject(e) {
            if (showUpdateModal && updateProjectRef.current && !updateProjectRef.current.contains(e.target)) {
                setShowUpdateModal(false);
            }

        }
        document.addEventListener("mousedown", closeUpdateProject);
        return () => document.removeEventListener("mousedown", closeUpdateProject)


    }, [showUpdateModal])


    const templateIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-folder2" viewBox="0 0 16 16"><path d="M1 3.5A1.5 1.5 0 0 1 2.5 2h2.764c.958 0 1.76.56 2.311 1.184C7.985 3.648 8.48 4 9 4h4.5A1.5 1.5 0 0 1 15 5.5v7a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 12.5zM2.5 3a.5.5 0 0 0-.5.5V6h12v-.5a.5.5 0 0 0-.5-.5H9c-.964 0-1.71-.629-2.174-1.154C6.374 3.334 5.82 3 5.264 3zM14 7H2v5.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5z" /></svg>

    const { project } = useParams();

    const toast = useToast();

    useEffect(() => {
        if (project === 'myprojects') {
            fetchprojectapi();
        }
    }, []);

    useEffect(() => {
        function closeOptionAnywar(e) {
            if (activeToggleUuid && optionref.current && !optionref.current.contains(e.target)) {
                console.log("the toogle is :", activeToggleUuid ? "opening" : "closing")
                setActiveToggleUuid(null);
            }
        }
        document.addEventListener("click", closeOptionAnywar);
        return () => document.removeEventListener("click", closeOptionAnywar);
    }, [activeToggleUuid])


    useEffect(() => {
        getallenvironments()
    }, [showUpdateModal, showmodal])


    const getallenvironments = async () => {
        try {
            setLoading(true);
            let response = await get_all_environment_Api();
            if (response.data) {
                setEnvironments(response.data)
            } else {
                let error = response.error.Message || "An error Occurred"
                toast({
                    title: "Problem getting Environmentfiles",
                    description: error,
                    status: "error",
                    duration: 2000,
                    isClosable: "true"
                })
            }
        } catch (error) {
            toast({
                title: "Problem getting Environmentfiles",
                description: error,
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
        } finally {
            setLoading(false);
        }
    }
    //MARK:fetch project
    const fetchprojectapi = async () => {
        toast({
            title: "Fetching projects",
            description: "Your projects are being fetched",
            status: "info",
            isClosable: "true"
        })
        let response = await get_all_project_Api();

        //console.log(response.data.projects);

        if (response.data !== null) {
            toast.closeAll()
            setProjects(response.data.projects)

        } else {
            toast({
                title: "No projects found",
                description: "error",
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
        }
    }








    const filteredProjects = projects.filter((p) => {
        const text = search.toLowerCase().trim();
        return p.name.toLowerCase().trim().startsWith(text);
    });
    console.log("filter projects", filteredProjects)

    const handleThreeDotClick = (e, uuid) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const dropdownHeight = 200; // approximate height of your dropdown
        const spaceBelow = window.innerHeight - rect.bottom;

        if (spaceBelow < dropdownHeight) {
            setDropdownPosition("top");
        } else {
            setDropdownPosition("bottom");
        }
        setActiveToggleUuid(prev => prev === uuid ? null : uuid);
    };
    const handleChange = (e) => {
        setProjectTitle({ name: e.target.value })
    }
    //MARK:create project
    const createFile = async (e) => {
        e.preventDefault();
        try {
            let envUuid = projectTitle.env; // If user selected existing environment
            // If creating a new environment/template
            if (activeTemplate === "create" && TemplateenvironmentTitle) {
                const envResult = await create_environment_Api(TemplateenvironmentTitle);

                if (!envResult.data) {
                    console.log("entering after project name creation")
                    const errorMessage = envResult.error?.message || "Failed to create environment";
                    toast({
                        title: "Environment Creation Failed",
                        description: errorMessage,
                        status: "error",
                        duration: 2000,
                        isClosable: true
                    });
                    return;
                }

                envUuid = envResult.data.uuid;

                // Upload files if any
                if (TemplateinputFiles.length > 0) {
                    const fileResult = await create_environment_file_Api(envUuid, TemplateinputFiles);
                    if (!fileResult.data) {
                        const errorMessage = fileResult.error?.message || "Failed to upload files";
                        toast({
                            title: "File Upload Failed",
                            description: errorMessage,
                            status: "error",
                            duration: 2000,
                            isClosable: true
                        });
                        return;
                    }
                }
            }

            // Now create the project with the environment UUID
            const projectResult = await create_project_Api(projectTitle.name, envUuid);
            if (projectResult.data) {
                setShowModal(false);
                toast({
                    title: "Project Created",
                    description: "Project created successfully",
                    status: "success",
                    duration: 2000,
                    isClosable: true
                });
                fetchprojectapi();
            } else {
                const errorMessage = projectResult.error?.message || "Failed to create project";
                toast({
                    title: "Project Creation Failed",
                    description: errorMessage,
                    status: "error",
                    duration: 2000,
                    isClosable: true
                });
            }

        } catch (err) {
            console.error(err);
            toast({
                title: "Error",
                description: "Something went wrong",
                status: "error",
                duration: 2000,
                isClosable: true
            });
        }
    };

    //MARK:update project
    const updateProject = async (e) => {
        e.preventDefault();
        // console.log(updatedata);
        let result = await update_project_Api(updatedata.id, updatedata.name, updatedata.env_name);
        if (result.data) {
            toast({
                title: "Updated project details",
                description: "Project details updated successfully",
                status: "success",
                duration: 2000,
                isClosable: "true"
            })
            setshowtemplatemodal(false);
            setShowUpdateModal(false);
            fetchprojectapi()
        } else {
            let error = result.error.message || "An error Occurred"
            toast({
                title: "Problem updating project",
                description: error,
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
        }
    }

    const handleDelete = async (id) => {
        let result = await delete_project_Api(id);
        if (result.data) {
            toast({
                title: "Project Deleted",
                description: "Project deleted successfully",
                status: "success",
                duration: 2000,
                isClosable: "true"
            })
            setProjects((prev) => prev.filter((items) => items.uuid !== id));
        } else {
            let error = result.error.message || "error Occured"
            toast({
                title: "Problem Deleting project",
                description: error,
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
        }
    }

    const handleUpdatedata = (item) => {
        setShowUpdateModal(true);
        setUpdatedata({ name: item.name, id: item.uuid, env_name: item.env_name })
    }
    const handleTemplateUpdatedata = (item) => {
        setshowtemplatemodal(!showtemplatemodal)
        setUpdatedata({ name: item.name, id: item.uuid, env_name: item.env_name })
    }

    const handlenewprojectcreation = () => {
        setShowModal(true);
        setProjectTitle({ name: '', env: "" })
    }

    const downloadLatestPdf = async (projectId) => {
        toast({
            title: "Downloading",
            description: "Downloading PDF",
            status: "info",
            duration: null,
            icon: (
                <Spinner
                    thickness="4px"
                    emptyColor="gray.200"
                    color="blue.500"
                    size="sm"
                />
            ),
        });
        var result = await getLatestProjectPdf(projectId);
        toast.closeAll();
        if (result.data) {
            downloadURI(
                "data:application/pdf;base64," + result.data.pdf,
                result.data.file
            );
            toast({
                title: "Downloading PDF.",
                description: "Download completed.",
                status: "success",
                duration: 2000,
            });
        } else {
            console.log(result);

            toast({
                title: "Download PDF Error",
                description: result.error.error,
                status: "error",
                duration: 2000,
            });
        }
    }

    const downloadLatestXML = async (projectId) => {
        toast({
            title: "Downloading",
            description: "Downloading XML",
            status: "info",
            duration: null,
            icon: (
                <Spinner
                    thickness="4px"
                    emptyColor="gray.200"
                    color="blue.500"
                    size="sm"
                />
            ),
        });
        var result = await getLatestProjectXML(projectId);
        toast.closeAll();
        if (result.data) {
            downloadFile(
                result.data.html,
                result.data.file,
                "html"
            );
            toast({
                title: "Downloading XML.",
                description: "Download completed.",
                status: "success",
                duration: 2000,
            });
        } else {
            toast({
                title: "Download XML Error",
                description: result.error.error,
                status: "error",
                duration: 2000,
            });
        }
    }

    const handleUpdateChange = (e) => {
        setUpdatedata({ ...updatedata, name: e.target.value });
    }

    // here after everthing is for Template creation
    const TemplatehandleClickOutside = (event) => {
        if (Templateref.current && !Templateref.current.contains(event.target) && !event.target.closest(".togglebtn")) {
            TemplatesetShow(false)
        }
    };

    const Templatehandledropdown = () => {
        if (Templateshow) {
            TemplatesetShow(false)
        } else {
            TemplatesetShow(true)
        }
    }

    useEffect(() => {
        let details = async () => {
            try {
                let result = await current_user_Api();
                if (result.data) {
                    TemplatesetUserDetail(result.data.message)
                }
            } catch (error) {
                console.log(error);
            }
        }

        details();

        document.addEventListener('mousedown', TemplatehandleClickOutside);
        // Cleanup event listener on component unmount
        return () => {
            document.removeEventListener('mousedown', TemplatehandleClickOutside);
        };
    }, [])

    const Templatenavigate = useNavigate();

    const Templatetoast = useToast();

    useEffect(() => {
        TemplatefetchEnvironemnt()
    }, [])

    const TemplatefetchEnvironemnt = async () => {
        let result = await get_all_environment_Api();
        if (result.data) {
            TemplatesetEnvironments(result.data)
        } else {
            const error = result.error.Message || "An error Occured";
            toast({
                title: "Problem getting Templates",
                description: error,
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
        }
    }


    const TemplatehandleDragOver = (e) => {
        e.preventDefault();
        TemplatesetDragging(true); // Highlight the area when dragging files
    };

    const TemplatehandleDragLeave = () => {
        TemplatesetDragging(false); // Remove highlight when leaving
    };

    const TemplatehandleDrop = (e) => {
        e.preventDefault();
        TemplatesetDragging(false); // Remove highlight when dropping files
        const files = e.dataTransfer.files;
        TemplatehandleFiles(files); // Handle dropped files
    };

    const TemplatehandleFiles = (files) => {
        let size = 3000;
        let allowedfiles = [];
        let count = 0;
        const fileslist = Array.from(files)
        for (let n of fileslist) {
            count += (n.size * 0.001)
            if (count < size) {
                allowedfiles.push(n)
                console.log(count);
            }
        }
        if (fileslist.length !== allowedfiles.length) {
            toast({
                title: "Total Files size should be less than 3mb",
                description: "",
                duration: "2000",
                status: "warning",
                isClosable: "true"
            })
        }
        TemplatesetInputFiles(prevFiles => [...prevFiles, ...allowedfiles]);
        // TemplatesetInputFiles(allowedfiles)
    };

    const TemplatehandleClick = () => {
        TemplatefileInputRef.current.click(); // Trigger file input click
    };

    const TemplatehandleChange = (e) => {
        TemplatesetEnvironmentTitle(e.target.value)
    }

    const TemplatecreateFile = async (e) => {
        e.preventDefault();

        let result = await create_environment_Api(TemplateenvironmentTitle);

        if (result.data) {
            let updateresult = await update_project_Api(updatedata.id, updatedata.name, result.data.uuid);
            if (updateresult.data) {
                toast({
                    title: "Updated project details",
                    description: "Project details updated successfully",
                    status: "success",
                    duration: 2000,
                    isClosable: "true"
                })

                fetchprojectapi()
            } else {
                let error = result.error.message || "An error Occurred"
                toast({
                    title: "Problem updating project",
                    description: error,
                    status: "error",
                    duration: 2000,
                    isClosable: "true"
                })
            }

            // setshowtemplatemodal(false)
            toast({
                title: "Environment created successfully",
                description: "",
                status: "success",
                duration: 2000,
                isClosable: "true"
            })
            if (TemplateinputFiles.length > 0) {
                let file = await create_environment_file_Api(result.data.uuid, TemplateinputFiles)
                if (file.data) {
                    setShowModal(false)
                    toast({
                        title: "Files uploaded successfully",
                        description: "",
                        status: "success",
                        duration: 2000,
                        isClosable: "true"
                    })
                } else {
                    const errorMessage = file.error.message || "An error occurred"
                    toast({
                        title: "Problem uploading files ",
                        description: errorMessage,
                        status: "error",
                        duration: 2000,
                        isClosable: "true"
                    })
                    TemplatesetInputFiles([])
                }
                TemplatefetchEnvironemnt()
            } else {
                setshowtemplatemodal(false)
                TemplatefetchEnvironemnt()
            }
        } else {
            const errorMessage = result.error.message || "An error occurred.";
            toast({
                title: "Problem getting files",
                description: errorMessage,
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
        }
    }



    const TemplatehandleDelete = (todelete) => {
        TemplatesetInputFiles((prev) => prev.filter(file => file.name != todelete))
    }

    const TemplateshowEnvDetails = (env, i) => {
        TemplatesetShowDetails({ show: true, env: env, id: i })
    }



    return (
        <div className={styles.product_page_outer}>
            {filteredProjects.length > 0 ?
                <div className={styles.indivprojectouter}>
                    <div className={styles.project_heading}>
                        <div className={styles.dashboardSidebarIcon}>
                            <svg onClick={() => { if (window.innerWidth < 789) { ToogleSidebars(true) } }} width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 3H4C3.44772 3 3 3.44772 3 4V11C3 11.5523 3.44772 12 4 12H9C9.55228 12 10 11.5523 10 11V4C10 3.44772 9.55228 3 9 3Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M20 3H15C14.4477 3 14 3.44772 14 4V7C14 7.55228 14.4477 8 15 8H20C20.5523 8 21 7.55228 21 7V4C21 3.44772 20.5523 3 20 3Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M20 12H15C14.4477 12 14 12.4477 14 13V20C14 20.5523 14.4477 21 15 21H20C20.5523 21 21 20.5523 21 20V13C21 12.4477 20.5523 12 20 12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M9 16H4C3.44772 16 3 16.4477 3 17V20C3 20.5523 3.44772 21 4 21H9C9.55228 21 10 20.5523 10 20V17C10 16.4477 9.55228 16 9 16Z" stroke="currentColo" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            <p>All Projects</p>
                        </div>
                        <button onClick={handlenewprojectcreation}>+ New Projects</button>
                    </div>
                    <div className={styles.Dashboardmaincontents}>
                        <div className={styles.dashboardsearchoption}>

                            <p>Projects</p>
                            <div className={styles.dashboardsearchfield}>
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.75 5.41667C0.75 6.0295 0.870707 6.63634 1.10523 7.20252C1.33975 7.76871 1.68349 8.28316 2.11683 8.7165C2.55017 9.14984 3.06462 9.49358 3.63081 9.7281C4.197 9.96263 4.80383 10.0833 5.41667 10.0833C6.0295 10.0833 6.63634 9.96263 7.20252 9.7281C7.76871 9.49358 8.28316 9.14984 8.7165 8.7165C9.14984 8.28316 9.49358 7.76871 9.7281 7.20252C9.96263 6.63634 10.0833 6.0295 10.0833 5.41667C10.0833 4.80383 9.96263 4.197 9.7281 3.63081C9.49358 3.06462 9.14984 2.55017 8.7165 2.11683C8.28316 1.68349 7.76871 1.33975 7.20252 1.10523C6.63634 0.870707 6.0295 0.75 5.41667 0.75C4.80383 0.75 4.197 0.870707 3.63081 1.10523C3.06462 1.33975 2.55017 1.68349 2.11683 2.11683C1.68349 2.55017 1.33975 3.06462 1.10523 3.63081C0.870707 4.197 0.75 4.80383 0.75 5.41667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M12.75 12.75L8.75 8.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                                <input type='text' placeholder='Search Your Project' value={search}
                                    onChange={(e) => setSearch(e.target.value)} /></div>
                        </div>
                        <div ref={indivProjectListRef} className={styles.indivprojectlist}>

                            {filteredProjects ? filteredProjects.map((item, i) => (
                                <div key={i} className={styles.indivproject}>
                                    <div className={styles.projectContainer}>

                                        <div className={styles.nameContainer}>
                                            <div className={styles.dashboardfileicons}>{templateIcon()}</div>
                                            <div className={styles.nameanddatecontainer}>
                                                <h2>{item.name}</h2>

                                                <div className={styles.dateandproject}>

                                                    {/* <p style={{ textWrap: "nowrap", overflow: "hidden" }} title={item.env_name} >
                                     {item.env_name}</p> */}
                                                    {
                                                        item.env_name && (
                                                            <>
                                                                <div className={styles.templateContainer}>
                                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M13.3333 13.3333C13.6869 13.3333 14.026 13.1929 14.2761 12.9428C14.5261 12.6928 14.6666 12.3536 14.6666 12V5.33333C14.6666 4.97971 14.5261 4.64057 14.2761 4.39052C14.026 4.14048 13.6869 4 13.3333 4H8.06659C7.84359 4.00219 7.62362 3.94841 7.42679 3.84359C7.22995 3.73877 7.06256 3.58625 6.93992 3.4L6.39992 2.6C6.27851 2.41565 6.11323 2.26432 5.91892 2.1596C5.7246 2.05488 5.50732 2.00004 5.28658 2H2.66659C2.31296 2 1.97382 2.14048 1.72378 2.39052C1.47373 2.64057 1.33325 2.97971 1.33325 3.33333V12C1.33325 12.3536 1.47373 12.6928 1.72378 12.9428C1.97382 13.1929 2.31296 13.3333 2.66659 13.3333H13.3333Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M1.33325 6.6665H14.6666" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </svg>

                                                                    <p>
                                                                        {item.env_name}</p>
                                                                </div>

                                                            </>
                                                        )
                                                    }


                                                    <div className={styles.dashboardDatestyle}>
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M7.33325 9.33301H7.99992V11.9997" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M10.6667 1.33301V3.99967" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M2 6.66699H14" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M5.33325 1.33301V3.99967" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M12.6667 2.66699H3.33333C2.59695 2.66699 2 3.26395 2 4.00033V13.3337C2 14.07 2.59695 14.667 3.33333 14.667H12.6667C13.403 14.667 14 14.07 14 13.3337V4.00033C14 3.26395 13.403 2.66699 12.6667 2.66699Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                                        </svg>

                                                        <p >

                                                            {new Date(item.date).toLocaleDateString("en-GB", {
                                                                day: "2-digit",
                                                                month: "short",
                                                                year: "numeric",
                                                            })}</p>
                                                    </div>

                                                </div>

                                            </div>

                                        </div>



                                        <div className={styles.dashboardoptions}>
                                            <div >
                                                <button className={styles.dashboardaddTemplatebutton} onClick={() => storeCurrentProject(item)}>

                                                    add style
                                                </button>
                                                {/* <Modal show={SettingsModal}>
                                                    <div className={templatestyle.warningcontainer}>
                                                        <div className={templatestyle.TemplateHeaderContainer}>
                                                            <p >Manage Styles</p>
                                                            <button onClick={() => setSettingsModal(false)}>
                                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                </svg>
                                                            </button>
                                                        </div>
                                                        <div>
                                                            <ManageProjectStyle setSettingsModal={setSettingsModal} data={currentProject} />
                                                        </div>
                                                    </div>
                                                </Modal> */}
                                                <NewModal show={SettingsModal} >
                                                    <div ref={styleRef} className={templatestyle.warningcontainer}>
                                                        <div className={templatestyle.TemplateHeaderContainer}>
                                                            <p >Manage Styles</p>
                                                            <button onClick={() => { setSettingsModal(false); setSelectedClientStyles([]); setShowDescription(false) }}>
                                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                </svg>
                                                            </button>
                                                        </div>

                                                        <div>

                                                            <div className={manageStyle.stylecontainer}>


                                                                <div className={manageStyle.clientContainer}>
                                                                    <div className={manageStyle.BothSideContainer}>
                                                                        <div className={manageStyle.LeftsideContainer}>
                                                                            <div className={manageStyle.stylePreviewContainer}>
                                                                                <h1 style={{ color: "#222" }}>Styles*</h1>
                                                                                <div className={manageStyle.searchContainer}>
                                                                                    <input type='text' value={searchStyles} onChange={searchingStyles}
                                                                                        className={manageStyle.searchinput}
                                                                                    />
                                                                                    <svg className={manageStyle.searchicon} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 24 24">
                                                                                        <path d="M 9 2 C 5.1458514 2 2 5.1458514 2 9 C 2 12.854149 5.1458514 16 9 16 C 10.747998 16 12.345009 15.348024 13.574219 14.28125 L 14 14.707031 L 14 16 L 20 22 L 22 20 L 16 14 L 14.707031 14 L 14.28125 13.574219 C 15.348024 12.345009 16 10.747998 16 9 C 16 5.1458514 12.854149 2 9 2 z M 9 4 C 11.773268 4 14 6.2267316 14 9 C 14 11.773268 11.773268 14 9 14 C 6.2267316 14 4 11.773268 4 9 C 4 6.2267316 6.2267316 4 9 4 z"></path>
                                                                                    </svg>
                                                                                </div>

                                                                                <div className={manageStyle.stylePreviewBox}>
                                                                                    {filteredStyles.length > 0 ?
                                                                                        filteredStyles.map(([keyName, value]) => (
                                                                                            <div
                                                                                                key={keyName}
                                                                                                style={{
                                                                                                    display: "flex",
                                                                                                    alignItems: "center",
                                                                                                    justifyContent: "space-between",
                                                                                                    gap: "10px",
                                                                                                }}
                                                                                                className={selecteddescription?.name === keyName && manageStyle.currentDiscription}
                                                                                            >
                                                                                                <div className={manageStyle.individualstyle}>
                                                                                                    <input
                                                                                                        type="checkbox"
                                                                                                        checked={selectedClientStyles.includes(keyName)}
                                                                                                        onChange={() => handleCheckChange(keyName)}
                                                                                                    />

                                                                                                    <div onClick={(e) => {
                                                                                                        e.preventDefault();
                                                                                                        e.stopPropagation();
                                                                                                        setSelectedDescription({ name: keyName, value: value });
                                                                                                        setShowDescription(true);

                                                                                                    }}

                                                                                                        className={manageStyle.individualstyle}
                                                                                                        style={{
                                                                                                            display: "flex",
                                                                                                            justifyContent: "space-between",
                                                                                                            width: "100%"
                                                                                                        }}
                                                                                                    >
                                                                                                        <label className={manageStyle.Textcolor}>{keyName}</label>
                                                                                                        <button
                                                                                                            onClick={(e) => {
                                                                                                                e.preventDefault();
                                                                                                                e.stopPropagation();
                                                                                                                setSelectedDescription({ name: keyName, value: value });
                                                                                                                setShowDescription(true);

                                                                                                            }}
                                                                                                            style={{
                                                                                                                background: "none",
                                                                                                                border: "none",
                                                                                                                cursor: "pointer",
                                                                                                                padding: "5px"
                                                                                                            }}
                                                                                                        >
                                                                                                            <InfoOutlineIcon className={manageStyle.Textcolor} />
                                                                                                        </button>
                                                                                                    </div>
                                                                                                </div>

                                                                                            </div>
                                                                                        )) : (
                                                                                            <>
                                                                                                <p>No Styles</p>
                                                                                            </>
                                                                                        )

                                                                                    }
                                                                                </div>
                                                                            </div>


                                                                        </div>
                                                                        <div className={manageStyle.RightsideContainer}>
                                                                            <div className={manageStyle.descriptionViewContainer}>

                                                                                <div style={{
                                                                                    display: "flex",
                                                                                    justifyContent: "space-between",
                                                                                    alignItems: "center",
                                                                                    marginBottom: "20px"
                                                                                }}>
                                                                                    <h1 className={manageStyle.Textcolor}>{selecteddescription?.name}</h1>
                                                                                    {/* <button
                                                                                        onClick={() => {
                                                                                            setShowDescription(false);
                                                                                            setSelectedDescription(null);
                                                                                        }}
                                                                                        className={manageStyle.nextbutton}
                                                                                        style={{ width: "auto", padding: "8px 20px" }}
                                                                                    >
                                                                                        Close
                                                                                    </button> */}
                                                                                </div>

                                                                                <div style={{ color: "#222" }}>
                                                                                    <h3 className={manageStyle.Textcolor}>Description:</h3>
                                                                                    <p className={manageStyle.Textcolor} style={{ paddingBottom: "10px" }}>{selecteddescription?.value?.description || "No description available"}</p>
                                                                                    <p className={manageStyle.Textcolor} style={{ paddingBottom: "10px" }}>Before:</p>
                                                                                    {selecteddescription?.value?.beforeImage && (
                                                                                        <img
                                                                                            src={process.env.PUBLIC_URL + selecteddescription.value.beforeImage}
                                                                                            alt="After"
                                                                                            style={{ paddingBottom: "10px" }}
                                                                                        />
                                                                                    )}

                                                                                    <p className={manageStyle.Textcolor} style={{ paddingBottom: "10px" }}>After:</p>
                                                                                    {selecteddescription?.value?.afterImage && (
                                                                                        <img
                                                                                            src={process.env.PUBLIC_URL + selecteddescription.value.afterImage}
                                                                                            alt="After"
                                                                                            style={{ paddingBottom: "10px" }}
                                                                                        />
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className={manageStyle.nextbtn}>
                                                                        <button className={manageStyle.nextbutton} onClick={() => handleStore(item)}>
                                                                            Next
                                                                        </button>
                                                                    </div>
                                                                </div>






                                                            </div>


                                                        </div>

                                                    </div>
                                                </NewModal>




                                                {/* new trying ending */}
                                            </div>
                                            {
                                                !item.env_name && (<>
                                                    <button className={styles.dashboardaddTemplatebutton}
                                                        onClick={() => {

                                                            handleTemplateUpdatedata(item)
                                                        }}
                                                    >Add a Template</button>
                                                </>)
                                            }

                                            {/* <Link onClick={() => triggerPreStyle()} to={`/${item.uuid}/`}>Open to editor</Link>
                                             */}

                                            <Link to={`/${item.uuid}/`}>Open in editor</Link>


                                            <div ref={optionref} onClick={(e) => e.stopPropagation()} className={styles.threedotbutton}   >

                                                <button onClick={(e) => { handleThreeDotClick(e, item.uuid); }}>

                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M4.75 12C4.75 12.4641 4.93437 12.9092 5.26256 13.2374C5.59075 13.5656 6.03587 13.75 6.5 13.75C6.96413 13.75 7.40925 13.5656 7.73744 13.2374C8.06563 12.9092 8.25 12.4641 8.25 12C8.25 11.5359 8.06563 11.0908 7.73744 10.7626C7.40925 10.4344 6.96413 10.25 6.5 10.25C6.03587 10.25 5.59075 10.4344 5.26256 10.7626C4.93437 11.0908 4.75 11.5359 4.75 12Z" fill="#3D3D41" />
                                                        <path d="M10.25 12C10.25 12.4641 10.4344 12.9092 10.7626 13.2374C11.0908 13.5656 11.5359 13.75 12 13.75C12.4641 13.75 12.9092 13.5656 13.2374 13.2374C13.5656 12.9092 13.75 12.4641 13.75 12C13.75 11.5359 13.5656 11.0908 13.2374 10.7626C12.9092 10.4344 12.4641 10.25 12 10.25C11.5359 10.25 11.0908 10.4344 10.7626 10.7626C10.4344 11.0908 10.25 11.5359 10.25 12Z" fill="#3D3D41" />
                                                        <path d="M15.75 12C15.75 12.4641 15.9344 12.9092 16.2626 13.2374C16.5908 13.5656 17.0359 13.75 17.5 13.75C17.9641 13.75 18.4092 13.5656 18.7374 13.2374C19.0656 12.9092 19.25 12.4641 19.25 12C19.25 11.5359 19.0656 11.0908 18.7374 10.7626C18.4092 10.4344 17.9641 10.25 17.5 10.25C17.0359 10.25 16.5908 10.4344 16.2626 10.7626C15.9344 11.0908 15.75 11.5359 15.75 12Z" fill="#3D3D41" />
                                                    </svg>

                                                </button>

                                                {activeToggleUuid === item.uuid && (
                                                    <div style={{ zIndex: "2000" }} className={`${styles.dashboardtoogleoptions} ${dropdownPosition === "top" ? styles.topDropdown : ""
                                                        }`}>
                                                        <ul>
                                                            <li> <button title='Edit project' onClick={() => { handleUpdatedata(item); setActiveToggleUuid(null) }}>Edit</button></li>

                                                            <hr />
                                                            <li><button title='Download latest PDF' onClick={() => { downloadLatestPdf(item.uuid); setActiveToggleUuid(null) }}>Download PDF</button></li>
                                                            <li> <button title='Download latest XML' onClick={() => { downloadLatestXML(item.uuid); setActiveToggleUuid(null) }}>Download XML</button></li>
                                                            <hr />
                                                            <li>  <button title='Delete project' onClick={() => { handleDelete(item.uuid); setActiveToggleUuid(null) }}>Delete</button></li>
                                                        </ul>
                                                    </div>
                                                )}

                                            </div>
                                        </div>



                                    </div>


                                </div>
                            )) : ""}
                        </div>
                    </div>
                </div>



                :
                <div className={styles.indivprojectouter}>
                    <div className={styles.project_heading}>
                        <p>All Projects</p>
                        <button onClick={handlenewprojectcreation}>+ New Projects</button>
                    </div>
                    <div className={styles.Dashboardmaincontents}>


                        <div className={styles.dashboardsearchoption}>

                            <p>Projects</p>
                            <div className={styles.dashboardsearchfield}>
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.75 5.41667C0.75 6.0295 0.870707 6.63634 1.10523 7.20252C1.33975 7.76871 1.68349 8.28316 2.11683 8.7165C2.55017 9.14984 3.06462 9.49358 3.63081 9.7281C4.197 9.96263 4.80383 10.0833 5.41667 10.0833C6.0295 10.0833 6.63634 9.96263 7.20252 9.7281C7.76871 9.49358 8.28316 9.14984 8.7165 8.7165C9.14984 8.28316 9.49358 7.76871 9.7281 7.20252C9.96263 6.63634 10.0833 6.0295 10.0833 5.41667C10.0833 4.80383 9.96263 4.197 9.7281 3.63081C9.49358 3.06462 9.14984 2.55017 8.7165 2.11683C8.28316 1.68349 7.76871 1.33975 7.20252 1.10523C6.63634 0.870707 6.0295 0.75 5.41667 0.75C4.80383 0.75 4.197 0.870707 3.63081 1.10523C3.06462 1.33975 2.55017 1.68349 2.11683 2.11683C1.68349 2.55017 1.33975 3.06462 1.10523 3.63081C0.870707 4.197 0.75 4.80383 0.75 5.41667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M12.75 12.75L8.75 8.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <input type='text' placeholder='Search Your Project' value={search}
                                    onChange={(e) => setSearch(e.target.value)} /></div>
                        </div>
                        <div className={styles.Nocontent}>
                            <p>{loading ? "Loading..." : "No Projects"}</p>
                        </div>
                    </div>
                </div>

            }

            <Modal show={showmodal}>
                <div ref={newprojectRef} className={dashboardmodal.modalContainer}>
                    <div className={dashboardmodal.modalheadingContainer}>
                        <p>New Project</p>
                        <button onClick={() => setShowModal(false)}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>

                        </button>
                    </div>
                    <div className={dashboardmodal.modalContentContainer}>
                        <form className={dashboardmodal.formouter} method='POST' onSubmit={createFile}>
                            <div className={dashboardmodal.inputdiv}>
                                <label>Project Title<span style={{
                                    color: "var(--error)"
                                }}>*</span></label>
                                <input type='text'
                                    name='project_name'
                                    onChange={handleChange}
                                    maxLength={50}
                                    value={projectTitle.name}
                                    placeholder='Enter Project Name' required />

                                {!environment && (<>
                                    <label>Template</label>
                                    <div className={dashboardmodal.projectButtongrouping}>
                                        <button
                                            type="button"
                                            className={activeTemplate === "create" ? dashboardmodal.activeTab : ""}
                                            onClick={() => setActiveTemplate("create")}
                                        >
                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M3.3335 8H12.6668" stroke="curretColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M8 3.3335V12.6668" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>

                                            Create your own
                                        </button>
                                        <button
                                            type="button"
                                            className={`${dashboardmodal.browseButton} ${activeTemplate === "browse" ? dashboardmodal.activeTab : ""
                                                }`}
                                            onClick={() => setActiveTemplate("browse")}
                                        >
                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_988_7190)">
                                                    <path d="M8.00016 14.6668C11.6821 14.6668 14.6668 11.6821 14.6668 8.00016C14.6668 4.31826 11.6821 1.3335 8.00016 1.3335C4.31826 1.3335 1.3335 4.31826 1.3335 8.00016C1.3335 11.6821 4.31826 14.6668 8.00016 14.6668Z" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M8.00016 1.3335C6.28832 3.13093 5.3335 5.51799 5.3335 8.00016C5.3335 10.4823 6.28832 12.8694 8.00016 14.6668C9.71201 12.8694 10.6668 10.4823 10.6668 8.00016C10.6668 5.51799 9.71201 3.13093 8.00016 1.3335Z" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M1.3335 8H14.6668" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_988_7190">
                                                        <rect width="16" height="16" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>

                                            <p>Browse Template</p>
                                        </button>
                                    </div>

                                    {activeTemplate === "create" ? (
                                        <div className={dashboardmodal.createContent}>
                                            <label>Template & Files Title<span style={{ color: "var(--error)" }}>*</span></label>
                                            <input
                                                type="text"
                                                name="templateName"
                                                placeholder="Enter Template Title"
                                                required
                                            />
                                            <div className={dashboardmodal.uploadBox}>
                                                <input type="file" multiple />
                                                <p>Click to upload or drag and drop multiple files</p>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className={dashboardmodal.browseContent}>
                                            <p>Our Templates</p>
                                            <p>Explore a wide variety of ready-to-use templates to quickly start your projects.</p>
                                            <Link to={"/templates"} className={styles.browserContentlink}>Try it now</Link>
                                        </div>
                                    )}
                                </>)}

                                {
                                    environment && (<>
                                        <label>Template</label>
                                        <div className={dashboardmodal.projectButtongrouping}>
                                            <button
                                                type="button"
                                                className={activeTemplate === "current" ? dashboardmodal.activeTab : ""}
                                                onClick={() => setActiveTemplate("current")}>
                                                <div >{templateIcon()}</div>
                                                Your template
                                            </button>
                                            <button
                                                type="button"
                                                className={activeTemplate === "create" ? dashboardmodal.activeTab : ""}
                                                onClick={() => setActiveTemplate("create")}
                                            >
                                                + Create your own
                                            </button>
                                            <button
                                                type="button"
                                                className={`${dashboardmodal.browseButton} ${activeTemplate === "browse" ? dashboardmodal.activeTab : ""
                                                    }`}
                                                onClick={() => setActiveTemplate("browse")}
                                            >
                                                <img
                                                    src={process.env.PUBLIC_URL + "/NewPages/Dashboard/BrowseTemplate.svg"}
                                                    alt="Browse"
                                                />
                                                <p>Browse Template</p>
                                            </button>
                                        </div>

                                        {activeTemplate === "create" && (
                                            <>
                                                <div className={dashboardmodal.inputWrapper}>
                                                    <label>
                                                        {data.environmenttitle} Title <span className={dashboardmodal.required}>*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        name="environment_name"
                                                        onChange={TemplatehandleChange}
                                                        maxLength={50}
                                                        placeholder="Enter Environment Name"
                                                    />
                                                </div>


                                                <div
                                                    className={`${dashboardmodal.uploadBox} ${Templatedragging ? dashboardmodal.dragging : ""}`}
                                                    onDragOver={TemplatehandleDragOver}
                                                    onDragLeave={TemplatehandleDragLeave}
                                                    onDrop={TemplatehandleDrop}
                                                >
                                                    {!Templatedragging && (
                                                        <>

                                                            <div className={dashboardmodal.uploadicon}>
                                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M6.6665 13.3333L9.99984 10M9.99984 10L13.3332 13.3333M9.99984 10V17.5M16.6665 13.9524C17.6844 13.1117 18.3332 11.8399 18.3332 10.4167C18.3332 7.88536 16.2811 5.83333 13.7498 5.83333C13.5677 5.83333 13.3974 5.73833 13.3049 5.58145C12.2182 3.73736 10.2119 2.5 7.9165 2.5C4.46472 2.5 1.6665 5.29822 1.6665 8.75C1.6665 10.4718 2.36271 12.0309 3.48896 13.1613" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                                </svg>
                                                            </div>



                                                            <div className={dashboardmodal.uploadDashboardfile}>


                                                                <p><span> <a onClick={TemplatehandleClick}>Click to Upload</a></span> or drag and drop your files here or</p>
                                                            </div>


                                                            <input
                                                                type="file"
                                                                ref={TemplatefileInputRef}
                                                                style={{ display: "none" }}
                                                                multiple
                                                                onChange={(e) => TemplatehandleFiles(e.target.files)}
                                                            />
                                                        </>
                                                    )}

                                                    {Templatedragging && <div className={dashboardmodal.dragText}>Drag your file here</div>}
                                                </div>


                                                <div className={dashboardmodal.selectedList}>
                                                    {TemplateinputFiles.map((file, id) => (
                                                        <div key={id} className={dashboardmodal.fileItem}>
                                                            <span>
                                                                <p>{file.name}</p>
                                                                <p className={dashboardmodal.fileMeta}>
                                                                    {file.type} | {(file.size / 1024).toFixed(2)} kb
                                                                </p>
                                                            </span>
                                                            <button type='button' onClick={() => TemplatehandleDelete(file.name)}>Delete</button>
                                                        </div>
                                                    ))}
                                                </div>


                                            </>
                                        )} {activeTemplate === "browse" && (
                                            <div className={dashboardmodal.browseContent}>
                                                <h3>Our Templates</h3>
                                                <p>Explore a wide variety of ready-to-use templates to quickly start your projects.</p>
                                                <Link to={"/templates"} className={dashboardmodal.browserContentlink}>Try it now</Link>
                                            </div>
                                        )}
                                        {
                                            activeTemplate === "current" && (
                                                <div className={dashboardmodal.radioList}>
                                                    {environment && environment.length > 0 ? (
                                                        environment.map((env, idx) => (
                                                            <label key={idx} className={dashboardmodal.radioItem}>
                                                                <input
                                                                    type="radio"
                                                                    name="selectedEnvironment"
                                                                    value={env.uuid}
                                                                    checked={projectTitle.env === env.uuid}
                                                                    onChange={() =>
                                                                        setProjectTitle({ ...projectTitle, env: env.uuid })
                                                                    }
                                                                />
                                                                <span>{env.name}</span>

                                                            </label>
                                                        ))
                                                    ) : (
                                                        <p style={{ textAlign: "center" }}>No templates available. Create one.</p>
                                                    )}


                                                </div>
                                            )

                                        }

                                    </>)
                                }


                            </div>
                            <div className={dashboardmodal.actionbtn}>
                                <button className={dashboardmodal.btn1} onClick={() => setShowModal(false)}>Cancel</button>
                                <button className={dashboardmodal.btn2} type='submit'>Create</button>
                            </div>
                        </form>

                    </div>
                </div>


            </Modal>

            {/* Modal for Updating existing project */}
            < Modal show={showUpdateModal} >
                <div ref={updateProjectRef} className={dashboardmodal.modalouter}>
                    <div className={dashboardmodal.modalheadingContainer}>
                        <p>   Update Project</p>
                        <button onClick={() => setShowUpdateModal(false)}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>

                        </button>
                    </div>

                    <div className={dashboardmodal.modalContentContainer}>
                        <form className={dashboardmodal.formouter} method='PUT' onSubmit={updateProject}>
                            <div className={dashboardmodal.inputdiv}>

                                <label>Project Title<span style={{
                                    color: "var(--error)"
                                }}>*</span></label>
                                <input type='text'
                                    name='project_name'
                                    onChange={handleUpdateChange}
                                    value={updatedata.name}
                                    placeholder='Enter Project Name' required />

                                <label>Choose Environment<span style={{
                                    color: "var(--error)"
                                }}>*</span></label>
                                {/* <select value={updatedata.env_name || ""} onChange={(e) => { setUpdatedata({ ...updatedata, env_name: e.target.value }) }}>
                                <option value="" disabled>Select an Environment</option>
                                {environment ? environment.map((env, id) => (
                                    <option key={id} value={env.uuid}>{env.name}</option>
                                )) : <option disabled>Create an Environment</option>}
                            </select> */}
                                <div className={dashboardmodal.radioList}>

                                    {environment && environment.length > 0 ? (
                                        environment.map((env, idx) => (
                                            <label key={idx} className={dashboardmodal.radioItem}>
                                                <input
                                                    type="radio"
                                                    name="env"
                                                    value={env.uuid}
                                                    checked={updatedata.env_name === env.uuid}
                                                    onChange={() =>
                                                        setUpdatedata({ ...updatedata, env_name: env.uuid })
                                                    }
                                                />
                                                <span>{env.name}</span>
                                            </label>
                                        ))
                                    ) : (
                                        <p>No environments available. Please create one.</p>
                                    )}
                                </div>

                                {/* <input type='text' name='project_name' onChange={handleChange} value={projectTitle} placeholder='Enter Project Name' required /> */}
                            </div>
                            <div className={dashboardmodal.actionbtn}>
                                <button className={dashboardmodal.btn1} onClick={() => setShowUpdateModal(false)}>Cancel</button>
                                <button className={dashboardmodal.btn2} type='submit'>Update</button>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal >



            {/* add a new template*/}
            <Modal show={showtemplatemodal}>
                <div ref={addatemplateRef} className={dashboardmodal.modalContainer}>

                    <div className={dashboardmodal.modalheadingContainer}>
                        <p>Add a Template</p>
                        <button onClick={() => setshowtemplatemodal(false)}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>

                        </button>
                    </div>
                    <div className={dashboardmodal.modalContentContainer}>
                        <div className={dashboardmodal.projectButtongrouping}>
                            <button
                                className={TemplateactiveTab === "create" ? dashboardmodal.activeTab : dashboardmodal.tab}
                                onClick={() => TemplateSetActiveTab("create")}
                            >
                                + Create your own
                            </button>

                            <button
                                className={TemplateactiveTab === "uploaded" ? dashboardmodal.activeTab : dashboardmodal.tab}
                                onClick={() => TemplateSetActiveTab("uploaded")}
                            >
                                <img src={process.env.PUBLIC_URL + "/NewPages/Dashboard/UploadImage.svg"} alt="" />
                                <p>Uploaded Templates & Files</p>
                            </button>
                        </div>

                        {/* CREATE TEMPLATE SECTION */}
                        {TemplateactiveTab === "create" && (
                            <form className={dashboardmodal.formouter} method="POST" onSubmit={TemplatecreateFile}>
                                <div className={dashboardmodal.inputdiv}>
                                    <div className={dashboardmodal.inputWrapper}>
                                        <label>
                                            {data.environmenttitle} Title <span className={templatestyle.required}>*</span>
                                        </label>
                                        <input
                                            type="text"
                                            name="environment_name"
                                            onChange={TemplatehandleChange}
                                            maxLength={50}
                                            placeholder="Enter Environment Name"
                                            required
                                        />
                                    </div>

                                    {/* FILE UPLOAD BOX */}
                                    <div
                                        className={`${dashboardmodal.uploadBox} ${Templatedragging ? dashboardmodal.dragging : ""}`}
                                        onDragOver={TemplatehandleDragOver}
                                        onDragLeave={TemplatehandleDragLeave}
                                        onDrop={TemplatehandleDrop}
                                    >
                                        {!Templatedragging && (
                                            <>
                                                <img
                                                    src={process.env.PUBLIC_URL + "/NewPages/Dashboard/uploadTemplate.svg"}
                                                    alt=""
                                                />


                                                <div className={dashboardmodal.uploadDashboardfile}>


                                                    <p> <span> <a onClick={TemplatehandleClick}>Click to Upload</a></span>or drag and drop your files here or</p>
                                                </div>


                                                <input
                                                    type="file"
                                                    ref={TemplatefileInputRef}
                                                    style={{ display: "none" }}
                                                    multiple
                                                    onChange={(e) => TemplatehandleFiles(e.target.files)}
                                                />
                                            </>
                                        )}

                                        {Templatedragging && <div className={dashboardmodal.dragText}>Drag your file here</div>}
                                    </div>

                                    {/* SHOW SELECTED FILES IF ANY */}
                                    <div className={dashboardmodal.selectedList}>
                                        {TemplateinputFiles.map((file, id) => (
                                            <div key={id} className={dashboardmodal.fileItem}>
                                                <span>
                                                    <p>{file.name}</p>
                                                    <p className={dashboardmodal.fileMeta}>
                                                        {file.type} | {(file.size / 1024).toFixed(2)} kb
                                                    </p>
                                                </span>
                                                <button type='button' onClick={() => TemplatehandleDelete(file.name)}>Delete</button>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div className={dashboardmodal.actionbtn}>
                                    <button
                                        className={dashboardmodal.btn1}
                                        onClick={() => (setshowtemplatemodal(false), TemplatesetInputFiles([]))}
                                    >
                                        Cancel
                                    </button>
                                    <button className={dashboardmodal.btn2} type="submit">
                                        Create
                                    </button>
                                </div>
                            </form>
                        )}

                        {/* UPLOADED LIST SECTION */}
                        {TemplateactiveTab === "uploaded" && (
                            <div className={dashboardmodal.uploadedWrapper}>
                                <div className={dashboardmodal.uploadedTitle}>
                                    Uploaded {data.environmenttitle}
                                </div>
                                <form className={dashboardmodal.formouter} method='PUT' onSubmit={updateProject}>
                                    <div className={dashboardmodal.inputdiv}>
                                        <label>Choose Environment<span style={{
                                            color: "var(--error)"
                                        }}>*</span></label>
                                        {/* <select value={updatedata.env_name || ""} onChange={(e) => { setUpdatedata({ ...updatedata, env_name: e.target.value }) }}>
                                        <option value="" disabled>Select an Environment</option>
                                        {environment ? environment.map((env, id) => (
                                            <option key={id} value={env.uuid}>{env.name}</option>
                                        )) : <option disabled>Create an Environment</option>}
                                    </select> */}
                                        <div className={dashboardmodal.radioList}>

                                            {environment && environment.length > 0 ? (
                                                environment.map((env, idx) => (
                                                    <label key={idx} className={dashboardmodal.radioItem}>
                                                        <input
                                                            type="radio"
                                                            name="env"
                                                            value={env.uuid}
                                                            checked={updatedata.env_name === env.uuid}
                                                            onChange={(e) =>
                                                                setUpdatedata({ ...updatedata, env_name: e.target.value })
                                                            }
                                                        />
                                                        <span>{env.name}</span>
                                                    </label>
                                                ))
                                            ) : (
                                                <p>No environments available. Please create one.</p>
                                            )}
                                        </div>
                                    </div>


                                    <div className={dashboardmodal.actionbtn}>
                                        <button className={dashboardmodal.btn1} onClick={() => setshowtemplatemodal(false)}>Cancel</button>
                                        <button className={dashboardmodal.btn2} type='submit'>Update</button>
                                    </div>
                                </form>


                            </div>
                        )}
                    </div>
                </div>
            </Modal>


        </div >
    )
}

// export default Myproject
const mapStateToProps = (state, ownProps) => ({
    editToolStyles: state.toolStyles.function,
    isChecked: state.toolStyles.isChecked,
})
const mapDispatchToProps = (dispatch) => {
    return {
        eplStyles: (data) => dispatch({ type: "Submit", payload: data }),
        toolStyles: (data) => dispatch({ type: "ToolSubmit", payload: data }),
        editToolRejected: () => dispatch({ type: "EmptyReject", payload: [] }),
        // editToolAction: (data) => dispatch({ type: "EDITTOOL", payload: data }),
        clientSelect: (data) => dispatch({ type: "clientselect", payload: data })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Myproject);